import { Grid, Typography } from '@mui/material';
import FormView from '../../../components/views/formView';
import FieldText from '../../../components/general/fields/fieldText';
import AutocompleteField from '../../../components/general/fields/autocompleteField';
import MultipleEmailsField from '../../../components/general/fields/multipleEmailsField';
import DropZoneField from '../../../components/general/fields/dropzoneField';
import LoadingButtonGeneral from '../../../components/general/buttons/loadingButtonGeneral';
import RichText from '../../../components/richText';
import SearchIcon from '@mui/icons-material/Search';
import CloudUploadIcon from '@mui/icons-material/CloudUpload';
import { useEmailSending } from './hook';

export const EmailSending = () => {
    const {
        account,
        cases,
        attachments,
        formik,
        searching,
        sending,
        handleSearchAccount,
        handleOnChangeAttachments,
        handleSubmit,
    } = useEmailSending();

    return (
        <>
            <FormView title="Envio Email" />
            <Grid
                container
                spacing={{ xs: 1.5, md: 1.5 }}
                columnSpacing={{ xs: 1.5, sm: 1.5, md: 1.5 }}
                pt="20px"
                pb="60px"
            >
                <Grid item xs={12} md={4}>
                    <FieldText
                        label="Documento de la cuenta"
                        name="document"
                        value={formik.values.document}
                        onChange={formik.handleChange}
                        onBlur={formik.handleBlur}
                        touched={formik.touched.document}
                        errors={formik.errors.document}
                        disabled={searching || sending}
                    />
                </Grid>
                <Grid item xs={12} md={2}>
                    <LoadingButtonGeneral
                        title="Buscar"
                        startIcon={<SearchIcon />}
                        loading={searching}
                        disabled={searching || sending}
                        onClick={handleSearchAccount}
                    />
                </Grid>
                {account && (
                    <>
                        <Grid item xs={12} md={6}>
                            <Typography style={{ fontWeight: 'bold' }}>
                                {`${account.name ?? ''} ${
                                    account.lastName ?? ''
                                }`}
                            </Typography>
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <AutocompleteField
                                label="Caso relacionado"
                                name="caseId"
                                data={cases}
                                value={formik.values.caseId}
                                onChangeValue={(value: string) =>
                                    formik.setFieldValue('caseId', value)
                                }
                                touched={formik.touched.caseId}
                                errors={formik.errors.caseId}
                                disabled={searching || sending}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <MultipleEmailsField
                                label="Destinatarios"
                                name="recipients"
                                value={formik.values.recipients}
                                onChangeValue={(value: string[]) =>
                                    formik.setFieldValue('recipients', value)
                                }
                                onBlur={() =>
                                    formik.setFieldTouched('recipients')
                                }
                                required
                                touched={Boolean(formik.touched.recipients)}
                                errors={formik.errors.recipients}
                                disabled={searching || sending}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <FieldText
                                label="Asunto"
                                name="subject"
                                value={formik.values.subject}
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                touched={formik.touched.subject}
                                errors={formik.errors.subject}
                                disabled={searching || sending}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{ fontWeight: 'bold' }}>
                                Cuerpo del correo
                            </Typography>
                            <RichText
                                initialContent={formik.values.body}
                                editable
                                onContentChange={(content) =>
                                    formik.setFieldValue('body', content)
                                }
                            />
                            <Typography variant="body2" color="error">
                                {formik.touched.body && formik.errors.body
                                    ? formik.errors.body
                                    : ''}
                            </Typography>
                        </Grid>
                        <Grid item xs={12}>
                            <Typography style={{ fontWeight: 'bold' }}>
                                Archivos adjuntos
                            </Typography>
                            <DropZoneField
                                name="attachments"
                                title="Suelte los archivos aquí o haga click para subir (El tamaño total no debe superar 30MB)"
                                subtitle={null}
                                subtitle2={null}
                                maxFileSize={30 * 1024 * 1024}
                                onChange={handleOnChangeAttachments}
                            >
                                <CloudUploadIcon
                                    fontSize="large"
                                    color="warning"
                                />
                            </DropZoneField>
                        </Grid>
                        {attachments.length > 0 && (
                            <Grid item xs={12}>
                                <Typography variant="body2">
                                    {`${attachments.length} archivo(s) adjunto(s)`}
                                </Typography>
                            </Grid>
                        )}
                        <Grid item xs={12} mt={3}>
                            <LoadingButtonGeneral
                                title="Enviar"
                                loading={sending}
                                disabled={searching || sending}
                                onClick={handleSubmit}
                            />
                        </Grid>
                    </>
                )}
            </Grid>
        </>
    );
};